import React from 'react'
import agent from '../agent'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import moment from 'moment';
import {
    PRODUCT_LIST_PAGE_LOADED,
    PRODUCT_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import ProductList from './widgets/ProductList';

const mapStateToProps = state => ({
    ...state.product,
    appName: state.common.appName,
    token: state.common.token,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: PRODUCT_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: PRODUCT_LIST_PAGE_UNLOADED }),
});

class Products extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Products.getProducts(this.props.match.params.key)
        this.props.onLoad(payload);
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {

        return (
            <div className='pane'>
                <Link className="crumb" to={`/users/${this.props.match.params.key}`}>&laquo; back to user detail</Link>
                <h1>User Product list</h1>
                <ProductList products={this.props.products} loading={this.props.loading} />
            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products);



// WEBPACK FOOTER //
// ./src/components/Products.js